import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import styled from "styled-components";

const StyledPanel = styled.div`

    border-color: ${(p) => p.theme.colors.border};
    border-width:1px;
    border-style:solid;
    border-radius: 25px;
    padding:15px;
    min-height: 100px;
    //border-right-style: ${(props) => (props.warning ? "solid" : "none")};
}

`;

const Stacked = styled.span`
  font-size: 1.5em;
  color: #e68797;
`;

const StyledEmptyColumnPlaceholder = styled.div`
  color: #e68797;
  min-height: 100px;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
`;

// used if we have no children to create some space to put new components in
const EmptyColumnPlaceholder = ({
  AddComponentButton,
  componentsConfig = {},
  id,
  add,
  pageType,
  DropZone,
  fb3ClickMove,
  node,
  moveMode,
}) => {
  return (
    <StyledEmptyColumnPlaceholder>
      {moveMode ? (
        <DropZone
          className="fal fa-clone"
          onClick={(e) => {
            e.stopPropagation();
            fb3ClickMove({ src: moveMode, dst: id });
          }}
        />
      ) : (
        <React.Fragment>
          <FormattedMessage id="Panel.EmptyText" />
          <AddComponentButton
            compact={true}
            pageType={pageType}
            nodeType="Col"
            type="child"
            label="Add components"
            icon="fal fa-plus-hexagon"
            hoverIcon="fal fa-columns"
            componentsConfig={componentsConfig}
            id={id}
            add={add}
          />
        </React.Fragment>
      )}
    </StyledEmptyColumnPlaceholder>
  );
};

// This is an empty column

export default (props) => {
  const { extra = {}, children = [], moveMode = true, DropZone } = props;
  const { cols = 12 } = extra;

  return (
    <StyledPanel warning={children.length == 0}>
      {children}
      {children.length == 0 && <EmptyColumnPlaceholder {...props} />}
    </StyledPanel>
  );
};
